import React, {Component} from 'react';
import {Card, Layout} from 'antd';
import {TIRES, TIRES_EXCHANGE,} from '../definition/business';
import ServicesSectionFragment from './sectionFragment/ServicesSectionFragment';
import {DisplaySectionFragment} from './sectionFragment/displaySectionFragment';
import {ItemSectionFragment} from './sectionFragment/itemSectionFragment';
import Address from "../../../components/common/Address";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";

class SummaryFragment extends Component {

  render() {
    const {intl: {formatMessage}, reception, type, createAppointmentRequest, city, country, number, street, zipCode} = this.props;
    const {chosenMobility, selectedOptions = []} = createAppointmentRequest;
    const isTiresWheelsType = type === TIRES;
    const isTiresExchangeChecked = !!selectedOptions.find(o => o.id === TIRES_EXCHANGE);
    const receptionText = `customer.journey.step.dateReception.${reception}Reception`;

    return (
      <Layout style={{ backgroundColor: 'transparent' }}>
        <Card
          title={<h2>{formatMessage({ id: 'customer.journey.step.summary.title' }).toUpperCase()}</h2>}
          bordered={false}
          style={{ width: '100%', marginBottom: 25 }}
        >
          <DisplaySectionFragment title={formatMessage({id: 'customer.journey.step.summary.chosenService'})}>
            <div style={{paddingBottom: 20}}>
              <ServicesSectionFragment/>
            </div>
          </DisplaySectionFragment>
          {!isTiresWheelsType && (
            <DisplaySectionFragment title={formatMessage({id: 'customer.journey.step.summary.chosenMobility'})}>
              <ul style={{paddingInlineStart: 0}}>
                <ItemSectionFragment title={formatMessage({id: chosenMobility.mobilityOptionTitle})} description={chosenMobility.workspaceReservations ? formatMessage({id: 'customer.journey.step.workspaceReservation'}) : undefined}/>
              </ul>
            </DisplaySectionFragment>
          )}
          {!isTiresWheelsType && (
            <DisplaySectionFragment title={formatMessage({id: 'customer.journey.step.summary.chosenReception'})}>
              <ul style={{paddingInlineStart: 0}}>
                <ItemSectionFragment title={formatMessage({id: receptionText})}/>
              </ul>
            </DisplaySectionFragment>
          )}
          {(!isTiresWheelsType || isTiresExchangeChecked) && (
            <DisplaySectionFragment title={formatMessage({id: 'customer.journey.step.summary.yourAddress'})}>
              <Address address={{street, number, zipCode, city, country}} style={{paddingBottom: 36}}/>
            </DisplaySectionFragment>
          )}
        </Card>
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => ({

});

const mapStateToProps = state => ({
  createAppointmentRequest: state.createAppointmentRequest,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SummaryFragment)
);
